import { updateField } from "../../../api/fieldsApi";

export const ARTICLE_FIELD_DEFS = [
  { suffix: "slug", label: "Slug", fieldType: "text" },
  { suffix: "category", label: "Category", fieldType: "text" },
  { suffix: "title", label: "Title", fieldType: "text" },
  { suffix: "desc", label: "Description", fieldType: "textarea" },
  { suffix: "image", label: "Card image", fieldType: "image" },
  { suffix: "author", label: "Author", fieldType: "text" },
  { suffix: "date", label: "Date", fieldType: "text" },
  { suffix: "avatar", label: "Author avatar", fieldType: "image" },
  { suffix: "role", label: "Author role", fieldType: "text" },
];

export const EMPTY_ARTICLE_FORM = {
  slug: "",
  category: "",
  title: "",
  desc: "",
  image: "",
  author: "",
  date: "",
  avatar: "",
  role: "",
};

export function groupArticleFields(fields) {
  const byIndex = new Map();

  fields.forEach((field) => {
    const match = /^article_(\d+)_(.+)$/.exec(field.key || "");
    if (!match) return;
    const index = Number(match[1]);
    const suffix = match[2];
    if (!byIndex.has(index)) byIndex.set(index, {});
    byIndex.get(index)[suffix] = field;
  });

  return [...byIndex.entries()]
    .sort(([a], [b]) => a - b)
    .map(([index, fieldMap]) => ({ index, fields: fieldMap }));
}

export function groupFilterFields(fields) {
  return fields
    .filter((f) => /^filter_\d+$/.test(f.key || ""))
    .sort(
      (a, b) =>
        Number(a.key.split("_")[1]) - Number(b.key.split("_")[1])
    );
}

export function articleGroupToForm(articleGroup) {
  const form = { ...EMPTY_ARTICLE_FORM };
  ARTICLE_FIELD_DEFS.forEach((def) => {
    const field = articleGroup.fields[def.suffix];
    if (field) form[def.suffix] = field.value ?? "";
  });
  return form;
}

export function getArticleTitle(articleGroup, values = {}) {
  const titleField = articleGroup.fields.title;
  return (
    (titleField && values[titleField.id]) ||
    titleField?.value ||
    articleGroup.fields.slug?.value ||
    `Article ${articleGroup.index}`
  );
}

export async function syncArticleCount(sectionId, fields, articleGroups) {
  const countField = fields.find((f) => f.key === "article_count");
  if (!countField) return;

  const nextCount = String(articleGroups.length);
  if (String(countField.value ?? "") === nextCount) return;

  await updateField(countField.id, {
    label: countField.label,
    fieldType: countField.fieldType,
    isRequired: countField.isRequired,
    isPublished: countField.isPublished,
    sortOrder: countField.sortOrder,
    value: nextCount,
  });
}

export function slugifyTitle(title) {
  return String(title || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
